import React, { useCallback, useEffect, useRef, useState } from 'react'
import {
    Avatar,
    Card,
    Col,
    Drawer,
    Dropdown,
    Flex,
    Menu,
    Modal,
    Row,
    Skeleton,
    Space,
    Tooltip,
} from 'antd'
import TodoStyles from './createaskcss.less'

import {
    FormOutlined,
    UsergroupAddOutlined,
    FieldTimeOutlined,
    UnorderedListOutlined,
    PaperClipOutlined,
    WechatOutlined,
    UserOutlined,
} from '@ant-design/icons'
import { connect, useDispatch } from 'react-redux'
import { getusersdroplist } from '../../../Services/Helpdesk/Backlog'
import {
    type todoForminterface,
    type todoSatteInterface,
    type TaskData,
    type Task,
    type setTasks,
} from '../../../Types/HelpDesk/Cretetask'
import {
    GetSatusList,
    GetTaskData,
    GetTaskList,
    Saveprojectstaus,
    Saveuserstaus,
} from '../../../Services/Helpdesk/CreteTask'
import CreateTaskForm from './CreateTaskForm'
import CreateFollowersModal from './CreateFoolwers'
import CreateHours from './CreateHours'
import CreateattachmentModal from './Attachment'
import CreatesubtaskModal from './Tabs'
import ChatClient from './chatClient'
import {
    commonTableParams,
    setCommonTableParamsData,
} from '../../../Utils/CommontTable'
import { type TableParamsInterface } from '../../../Types/CommonType'
import { type ProjectManagmentStausListDataTypeInterface } from '../../../Types/ProjectMangement'
import { type DataCHAT } from '../../../Types/Client/ProspectClients/prospectClient'
import { formatdate } from '../../../Utils/dateFormat'
export const TaskdefaultData = {
    taskId: 0,
    taskNo: '',
    taskName: '',
    priorityId: 0,
    sortOrder: 0,
    taskType: 0,
    businessType: 0,
    referenceId: 0,
    serviceId: 0,
    serviceReferenceId: 0,
    assignedBy: 0,
    assignedTo: 0,
    fromDate: '',
    toDate: '',
    statusId: 0,
    notifyToStatusChange: 0,
    description: '',
    clientName: '',
    recurringFrequency: 1,
    recurringFrequencyType: 0,
    recurringFrequencyPeriodId: 0,
    recurringEnds: 0,
    recurringOccurrence: 1,
    recurringEndsOn: '01/01/1900',
    isRepeatOnSun: 0,
    isRepeatOnMon: 0,
    isRepeatOnTue: 0,
    isRepeatOnWed: 0,
    isRepeatOnThu: 0,
    isRepeatOnFri: 0,
    isRepeatOnSat: 0,
    projectTierId: 0,
    projectId: 0,
    departmentId: 0,
    sprintId: 0,
    projectStatusLbl: '',
    clientDynCategoryId: 0,
}

export const TaskItemDefaultData = {
    taskId: '',
    taskNo: 0,
    taskName: '',
    priorityName: '',
    priorityColourCode: '',
    taskTypeName: '',
    sortOrder: 0,
    businessTypeName: '',
    clientName: '',
    serviceName: '',
    description: '',
    assignedByName: '',
    assignedToName: '',
    fromDate: '',
    toDate: '',
    daysCount: 0,
    daysColourCode: '',
    status: '',
    statusColourCode: '',
    notifyToStatusChange: 0,
    subTaskViews: [],
    taskFollowerViews: [],
    subTaskStatus: 0,
    isNewChatExist: 0,
    projectTierInfo: '',
    projectStatusId: 0,
    projectStatusLbl: '',
    userStatusId: 0,
    userStatusLbl: '',
}

const ToDoTasks = (
    props: todoForminterface & { activeStates: string }
): React.ReactElement => {
    const dispatch = useDispatch()
    const [modalTitleCreate, setModalTitleCreate] = useState('Create')
    const [modalVisibleCreate, setModalVisibleCreate] = useState(false)
    const [modalVisibleCreateHours, setModalVisibleCreateHours] =
        useState(false)
    const [selectedTaskId, setSelectedTaskId] = useState<string>('')
    const [createEditModalStatus, setCreateEditModalStatus] = useState(false)
    const [, setSelectedStatusProjectId] = useState<string>('')
    const [modalVisibleCreateAttachment, setModalVisibleCreateAttachment] =
        useState(false)
    const [modalVisibleCreateChat, setModalVisibleCreateChat] = useState(false)
    const [modalVisibleCreateFollowers, setModalVisibleCreateFollowers] =
        useState(false)
    const [modalVisibleCreateSubTask, setModalVisibleCreateSubTask] =
        useState(false)
    const [attachmentTaskId, setAttachmentTaskId] = useState('')
    const [editData, setEditData] = useState<setTasks>(TaskdefaultData)
    const [tableParams] = useState<TableParamsInterface>(commonTableParams)
    const [, setLoading] = useState(false)
    const [idChange, setIDchange] = useState('')
    // const [uerStatusfilter, setUerStatusfilter] = useState(1)
    const [referenceId, setRefernceId] = useState(0)
    const [businessId, setBusinessId] = useState(0)
    const [getTask, setTask] = useState<Task>(TaskItemDefaultData)
    const hasFetchedOnce = useRef(false)
    const [restData, setResetData] = useState('false')
    const {
        // userimageList,
        ProjectManagmentStausList,
        setSelectedTaskIds,
        selectedProjectID,
        AssignBY,
        activeStates,
        taskDetailsList,
        activeTab,
        AssignTo,
        searchString,
        createTaskModalStatus,
        departmentId,
    } = props

    const [selectedUsers, setSelectedUsers] = useState<number[]>([])
    const [todoprojectlist, setTodoProjectDatalist] = useState<TaskData[]>([])
    const hasFetchedOnce4 = useRef(false)
    const [projectStatusLable, setProjectStatusLable] = useState('')
    const [restData2, setResetData2] = useState('false')
    const [drawerDetails, setDrawerDetaisl] = useState<DataCHAT | null>(null)
    const getTableToDOData = useCallback(() => {
        if (selectedProjectID === 0) {
            // setUerStatusfilter(1)
            void GetTaskList(
                dispatch,
                '0',
                searchString?.toString(),
                1,
                10000,
                AssignBY ?? 0,
                AssignTo ?? 0,
                departmentId,
                selectedProjectID
            )
        }
    }, [
        AssignTo,
        AssignBY,
        selectedProjectID,
        searchString,
        createTaskModalStatus,
        idChange,
        activeStates,
        departmentId,
        activeTab,
    ])

    useEffect(() => {
        getTableToDOData()
    }, [getTableToDOData])

    const getTableDatas = useCallback(() => {
        try {
            let projectStatusName = ''

            if (activeTab === '1') {
                projectStatusName = 'To-Do'
            } else if (activeTab === '3') {
                projectStatusName = 'QA'
            }

            const todoProject = ProjectManagmentStausList.find(
                (project) => project.projectStatusName === projectStatusName
            )

            const id = todoProject?.projectStatusId

            // if (id !== filterProjectStatusID) {
            //     setFilterProjectStatusID(id?.toString())
            // }

            if (
                id !== undefined &&
                selectedProjectID !== 0 &&
                selectedProjectID !== undefined
            ) {
                void GetTaskList(
                    dispatch,
                    id?.toString(),
                    searchString?.toString(),
                    1,
                    10000,
                    AssignBY ?? 0,
                    AssignTo ?? 0,
                    departmentId,
                    selectedProjectID
                )
                setLoading(false)
            }
        } catch {}
    }, [
        ProjectManagmentStausList,
        selectedProjectID,
        idChange,
        activeStates,
        activeTab,
        AssignBY,
        AssignTo,
        searchString,
        createTaskModalStatus,
        departmentId,
    ])
    useEffect(() => {
        if (!hasFetchedOnce4.current) {
            hasFetchedOnce4.current = true
            return
        }
        getTableDatas()
        hasFetchedOnce4.current = false
    }, [getTableDatas])

    useEffect(() => {
        if (activeTab !== '2') {
            const projectStatusLbl = activeTab === '3' ? 'QA' : 'To-Do'
            const userStatusLbl = 'To-Do'
            const InprogressData = taskDetailsList.filter(
                (data) =>
                    data.projectStatusLbl === projectStatusLbl &&
                    (data.userStatusLbl === userStatusLbl ||
                        data.userStatusLbl === '')
            )

            setTodoProjectDatalist(InprogressData)
        }
    }, [taskDetailsList, activeTab])
    const handleModalOpenCreate = (taskId: string): void => {
        setModalVisibleCreate(true)
        setAttachmentTaskId(taskId)
        setModalTitleCreate('Edit Task Details')
    }

    const handleModalOpenCreateHours = (taskId: string): void => {
        setModalVisibleCreateHours(true)
        setAttachmentTaskId(taskId)
        setModalTitleCreate('Add Spent Hours')
    }

    const handleModalOpenCreateFollowers = (taskId: string): void => {
        setModalVisibleCreateFollowers(true)
        setAttachmentTaskId(taskId)
        setModalTitleCreate('Add Followers')
    }

    const handleModalOpenSubTasks = (task: Task): void => {
        setModalVisibleCreateSubTask(true)
        setAttachmentTaskId(task.taskId)
        setTask(task)
        setModalTitleCreate('Add SubTask')
    }

    const onAttachment = (taskId: string): void => {
        setModalVisibleCreateAttachment(true)
        setAttachmentTaskId(taskId)
        setModalTitleCreate('Add Task Attachment')
    }

    const onChat = (
        taskId: string,
        referenceId: number,
        businessId: number
    ): void => {
        setRefernceId(referenceId)
        setBusinessId(businessId)
        setModalVisibleCreateChat(true)
        setAttachmentTaskId(taskId)
        setModalTitleCreate('Staff Communication')
    }

    const handleModalClose = (): void => {
        setModalVisibleCreate(false)
        setModalVisibleCreateAttachment(false)
        setModalVisibleCreateHours(false)
        setModalVisibleCreateFollowers(false)
        setModalVisibleCreateSubTask(false)
        setModalVisibleCreateChat(false)
    }

    const changeCreateEditModalStatus = (): void => {
        setCreateEditModalStatus(!createEditModalStatus)
        setModalVisibleCreate(false)
    }

    const onSaveTask = (callBack: CallableFunction): void => {
        setModalVisibleCreateFollowers(false)
        changeCreateEditModalStatus()
        callBack()
        getTableToDOData()
        getTableDatas()
    }

    useEffect(() => {
        if (!hasFetchedOnce.current) {
            hasFetchedOnce.current = true
            return
        }
        void getusersdroplist(dispatch)
    }, [])

    const getTableData = useCallback(() => {
        const { pageSize, pageNo, sortOrderList, searchCriteriaList } =
            setCommonTableParamsData(tableParams)
        if (selectedProjectID !== undefined && selectedProjectID !== null) {
            GetSatusList(dispatch, selectedProjectID?.toString(), {
                pageNo,
                pageSize,
                searchCriteriaList,
                sortOrderList,
            })
        }
    }, [selectedProjectID])

    useEffect(() => {
        getTableData()
    }, [getTableData])

    const handleAssignByMenuClick = (
        taskId: string,
        statusProjectId: string
    ): void => {
        setSelectedTaskId(taskId)
        setSelectedStatusProjectId(statusProjectId)
    }

    const todoProjectStatusId = (
        name: string | undefined
    ): string | undefined => {
        const todoProject = ProjectManagmentStausList.find(
            (project: ProjectManagmentStausListDataTypeInterface) =>
                project.projectStatusName === name
        )
        const todoProjectId = todoProject?.projectStatusId?.toString()

        return todoProjectId
    }

    const handleProgressChange = async (
        value: number,
        projectStatusName: string
    ): Promise<void> => {
        try {
            setLoading(true)
            const statusId = todoProjectStatusId(projectStatusName)
            let StatusIDS = 0

            if (statusId !== undefined) {
                StatusIDS = Number(statusId)
            } else {
                StatusIDS = 0
            }
            await Saveuserstaus(dispatch, selectedTaskId, value?.toString())
            await Saveprojectstaus(
                dispatch,
                selectedTaskId,
                Number(StatusIDS),
                projectStatusName
            )

            setIDchange(selectedTaskId)
            setSelectedTaskIds(selectedTaskId)
            getTableDatas()
        } catch (error) {
        } finally {
            setLoading(false)
        }
    }

    const openEditModal = (id: string): void => {
        void openEditData(id)
    }
    const openEditData = async (id: string): Promise<void> => {
        // const data = taskDetailsList.find((data: TaskData) => {
        //     return data.taskId === id
        // })
        try {
            const data = await GetTaskData(dispatch, id)
            setEditData(data ?? TaskdefaultData)
        } catch (err) {}
    }
    return (
        <div>
            {todoprojectlist.length === 0 ? (
                <Card className={TodoStyles.todoCard} title="TO-DO">
                    <div>No records available</div>
                </Card>
            ) : (
                <Card className={TodoStyles.todoCard} title="TO-DO">
                    {todoprojectlist
                        // .filter(
                        //     (task: { userStatusId: number }) =>
                        //         task.userStatusId === 1
                        // )
                        .map((task: TaskData) => (
                            <Card
                                key={task.taskId}
                                className={TodoStyles.todoItem}
                            >
                                <div className={TodoStyles.tasknameStyles}>
                                    <div>
                                        <strong>{task.taskName}</strong> {'  '}
                                        {task.clientName !== '' && (
                                            <span>({task.clientName})</span>
                                        )}
                                    </div>
                                    <div className={TodoStyles.taskAndColor}>
                                        <div>
                                            <Dropdown
                                                overlay={
                                                    <Menu
                                                        onClick={({ key }) => {
                                                            handleAssignByMenuClick(
                                                                task.taskId,
                                                                key
                                                            )
                                                        }}
                                                    >
                                                        {activeTab === '1' ? (
                                                            <>
                                                                <Menu.Item
                                                                    key="todo"
                                                                    onClick={() => {
                                                                        void handleProgressChange(
                                                                            1,
                                                                            'To-Do'
                                                                        )
                                                                    }}
                                                                >
                                                                    To-Do
                                                                </Menu.Item>
                                                                <Menu.Item
                                                                    key="inprogress"
                                                                    onClick={() => {
                                                                        void handleProgressChange(
                                                                            2,
                                                                            'In-Progress'
                                                                        )
                                                                    }}
                                                                >
                                                                    In-Progress
                                                                </Menu.Item>
                                                                <Menu.Item
                                                                    key="completed"
                                                                    onClick={() => {
                                                                        void handleProgressChange(
                                                                            3,
                                                                            'Complete'
                                                                        )
                                                                    }}
                                                                >
                                                                    Completed
                                                                </Menu.Item>
                                                                <Menu.Item
                                                                    key="QA"
                                                                    onClick={() => {
                                                                        void handleProgressChange(
                                                                            1,
                                                                            'QA'
                                                                        )
                                                                    }}
                                                                >
                                                                    QA
                                                                </Menu.Item>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <Menu.Item
                                                                    key="todo"
                                                                    onClick={() => {
                                                                        void handleProgressChange(
                                                                            1,
                                                                            'QA'
                                                                        )
                                                                    }}
                                                                >
                                                                    To-Do
                                                                </Menu.Item>
                                                                <Menu.Item
                                                                    key="inprogress"
                                                                    onClick={() => {
                                                                        void handleProgressChange(
                                                                            2,
                                                                            'QA'
                                                                        )
                                                                    }}
                                                                >
                                                                    In-Progress
                                                                </Menu.Item>
                                                                <Menu.Item
                                                                    key="completed"
                                                                    onClick={() => {
                                                                        void handleProgressChange(
                                                                            3,
                                                                            'Complete'
                                                                        )
                                                                    }}
                                                                >
                                                                    Completed
                                                                </Menu.Item>
                                                            </>
                                                        )}
                                                    </Menu>
                                                }
                                                visible={
                                                    selectedTaskId ===
                                                    task.taskId
                                                }
                                                onVisibleChange={(visible) => {
                                                    if (!visible) {
                                                        setSelectedTaskId('')
                                                        setSelectedStatusProjectId(
                                                            ''
                                                        )
                                                    }
                                                }}
                                            >
                                                <a
                                                    className="ant-dropdown-link"
                                                    onClick={(e) => {
                                                        e.preventDefault()
                                                        setSelectedTaskId(
                                                            task.taskId
                                                        )
                                                    }}
                                                >
                                                    To-Do
                                                </a>
                                            </Dropdown>
                                        </div>
                                        <div
                                            className={TodoStyles.circle}
                                            style={{
                                                backgroundColor:
                                                    task.daysColourCode,
                                            }}
                                        ></div>
                                    </div>
                                </div>
                                <Flex justify="space-between">
                                    <div className={TodoStyles.iconContainer}>
                                        <Tooltip title="Edit Task">
                                            <FormOutlined
                                                className={TodoStyles.todoIcons}
                                                onClick={() => {
                                                    handleModalOpenCreate(
                                                        task.taskId
                                                    )
                                                    setProjectStatusLable(
                                                        task.projectStatusLbl
                                                    )
                                                    openEditModal(task.taskId)
                                                    setResetData('false')
                                                }}
                                            />
                                        </Tooltip>
                                        <Tooltip title="Add Followers">
                                            <UsergroupAddOutlined
                                                className={TodoStyles.todoIcons}
                                                onClick={() => {
                                                    handleModalOpenCreateFollowers(
                                                        task.taskId
                                                    )
                                                    setResetData2('true')
                                                }}
                                            />
                                        </Tooltip>
                                        <Tooltip title="Add Spent Hours">
                                            <FieldTimeOutlined
                                                className={TodoStyles.todoIcons}
                                                onClick={() => {
                                                    handleModalOpenCreateHours(
                                                        task.taskId
                                                    )
                                                    setResetData('true')
                                                }}
                                            />
                                        </Tooltip>
                                        <Tooltip title="Add subtask">
                                            <UnorderedListOutlined
                                                className={TodoStyles.todoIcons}
                                                onClick={() => {
                                                    handleModalOpenSubTasks(
                                                        task
                                                    )
                                                    setResetData('true')
                                                }}
                                            />
                                        </Tooltip>
                                        <Tooltip title="Add Task Attachment">
                                            <PaperClipOutlined
                                                className={TodoStyles.todoIcons}
                                                onClick={() => {
                                                    onAttachment(task.taskId)
                                                    setResetData('true')
                                                }}
                                            />
                                        </Tooltip>
                                        <Tooltip title="Staff Communication">
                                            <WechatOutlined
                                                className={TodoStyles.todoIcons}
                                                onClick={() => {
                                                    onChat(
                                                        task.taskId,
                                                        task.referenceId,
                                                        task.businessTypeId
                                                    )
                                                    setResetData('true')
                                                }}
                                            />
                                        </Tooltip>
                                    </div>
                                    <div>
                                        <Space size={'small'}>
                                            <Tooltip
                                                title={` Assigned By ${task?.assignedByName}`}
                                            >
                                                <UserOutlined />
                                            </Tooltip>
                                            <Tooltip
                                                title={` Assigned To ${task?.assignedToName}`}
                                            >
                                                <UserOutlined />
                                            </Tooltip>
                                        </Space>
                                    </div>

                                    <div
                                        style={{
                                            display: 'grid',
                                            gridTemplateColumns:
                                                'repeat(3, auto)',
                                            gap: '4px',
                                        }}
                                    >
                                        {task.taskFollowerViews
                                            .filter(
                                                (follower) =>
                                                    follower?.followerImageURL !==
                                                    null
                                            )
                                            .map((follower) => (
                                                <Tooltip
                                                    key={follower.followerId}
                                                    title={`${follower.followerName}`}
                                                >
                                                    <Avatar
                                                        size={20}
                                                        src={
                                                            follower.followerImageURL
                                                        }
                                                    />
                                                </Tooltip>
                                            ))}
                                    </div>
                                </Flex>
                            </Card>
                        ))}
                </Card>
            )}
            {/* </Spin> */}
            <Modal
                title={modalTitleCreate}
                open={modalVisibleCreate}
                onCancel={handleModalClose}
                footer={null}
                width={'50%'}
            >
                <CreateTaskForm
                    taskId={attachmentTaskId?.toString()}
                    onSave={onSaveTask}
                    editData={editData}
                    setResetData={setResetData}
                    resetdata={restData}
                    projectStatusLable={projectStatusLable}
                />
            </Modal>
            <Modal
                title={modalTitleCreate}
                open={modalVisibleCreateAttachment}
                onCancel={handleModalClose}
                footer={null}
                width={'50%'}
            >
                <CreateattachmentModal
                    taskId={attachmentTaskId}
                    setResetData={setResetData}
                    resetdata={restData}
                />
            </Modal>
            <Modal
                title={modalTitleCreate}
                open={modalVisibleCreateHours}
                onCancel={handleModalClose}
                footer={null}
                width={'50%'}
            >
                <CreateHours
                    taskid={attachmentTaskId}
                    setResetData={setResetData}
                    resetdata={restData}
                    areaId={1}
                />
            </Modal>
            <Modal
                title={modalTitleCreate}
                open={modalVisibleCreateFollowers}
                onCancel={handleModalClose}
                footer={null}
                width={'30%'}
            >
                <CreateFollowersModal
                    onSave={onSaveTask}
                    taskid={attachmentTaskId?.toString()}
                    selectedUsers={selectedUsers}
                    setSelectedUsers={setSelectedUsers}
                    resetdata={restData2}
                    setResetData={setResetData2}
                />
            </Modal>
            <Modal
                title={modalTitleCreate}
                open={modalVisibleCreateSubTask}
                onCancel={handleModalClose}
                footer={null}
                width={'50%'}
            >
                <CreatesubtaskModal
                    taskId={attachmentTaskId}
                    getTask={getTask}
                    setResetData={setResetData}
                    restData={restData}
                />
            </Modal>
            <Drawer
                title={
                    drawerDetails !== null ? (
                        <>
                            <Row>
                                <Col span={24}>
                                    <span style={{ color: 'white' }}>
                                        {drawerDetails.clientName}
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    Period of{' '}
                                    {formatdate(drawerDetails.periodStartDate)}{' '}
                                    to {formatdate(drawerDetails.periodEndDate)}
                                </Col>
                            </Row>
                        </>
                    ) : (
                        <Skeleton active />
                    )
                }
                open={modalVisibleCreateChat}
                onClose={handleModalClose}
                footer={null}
                width={550}
                styles={{
                    header: {
                        backgroundColor: '#085394',
                        padding: '20px',
                        marginBottom: '0',
                        color: 'white',
                    },
                    content: { padding: '0' },
                    body: { backgroundColor: 'yello' },
                }}
            >
                <ChatClient
                    taskId={Number(attachmentTaskId)}
                    messageTypeId={2}
                    referenceId={referenceId}
                    businessId={businessId}
                    setDrawerDetaisl={setDrawerDetaisl}
                    setResetData={setResetData}
                    resetdata={restData}
                />
            </Drawer>
        </div>
    )
}

const mapStateToProps = (state: any): todoSatteInterface => {
    return {
        userList: state.user.userList,
        projectDropDownList: state.helpdesk.projectDropDownList,
        taskDetailsListCount: state.helpdesk.taskDetailsListCount,
        userimageList: state.helpdesk.userimageList,
        ProjectManagmentStausList: state.initial.ProjectManagmentStausList,
        taskDetailsList: state.helpdesk.taskDetailsList,
    }
}

export default connect(mapStateToProps)(ToDoTasks)
